import { Embroidery, StateObj } from 'src/types'
import {
  notThumbEmbroidery,
  liningEmbroidery,
  thumbEmbroidery,
  bottomRightOfBeltEmbroidery,
  sideOfLabelEmbroidery,
  dWaveEmbroidery
} from 'src/features/dxm/drawer/common/back/embroidery'

const liningEmbroideryObject = {
  first: {
    x: 110,
    y: -75,
    position: 'leatherLiningFirst'
  },
  second: {
    x: 115,
    y: -34,
    position: 'leatherLiningSecond'
  }
}

const compare = (e: Embroidery) => (target: string) => e.position.value === target

export const liningEmbroideryDrawer = (
  ctx: CanvasRenderingContext2D,
  embroideries: Embroidery[],
  step: 'first' | 'second',
  fontSize?: string
): void => {
  const matcher = (e: Embroidery) => compare(e)(liningEmbroideryObject[step].position)
  const isEmbroideryOfLining = embroideries?.some(matcher)
  if (!isEmbroideryOfLining) return
  liningEmbroidery(ctx, embroideries.find(matcher), liningEmbroideryObject[step].x, liningEmbroideryObject[step].y, fontSize)
}

export const thumbEmbroideryDrawer = (ctx: CanvasRenderingContext2D, embroideries: Embroidery[], backStyle: StateObj): void => {
  const matcher = (e: Embroidery) => compare(e)('thumbFinger')
  const isEmbroideryDraw = embroideries?.some(matcher)
  if (!isEmbroideryDraw) return
  switch (backStyle.value) {
    case 'dWave':
      thumbEmbroidery(ctx, embroideries.find(matcher), -65, 23, -15)
      break
    default:
      thumbEmbroidery(ctx, embroideries.find(matcher), -115, 30, -15)
      break
  }
}

const nonThumbEmbroideryObject = {
  middleFinger: {
    x: -140,
    y: -190,
    numerator: 5
  },
  ringFinger: {
    x: -60,
    y: -80,
    numerator: -5
  },
  childFinger: {
    x: -70,
    y: -45,
    numerator: -2
  }
}

export const nonThumbEmbroideryDrawer = (
  ctx: CanvasRenderingContext2D,
  fingerType: 'middleFinger' | 'ringFinger' | 'childFinger',
  embroideries: Embroidery[]
): void => {
  const matcher = (e: Embroidery) => compare(e)(fingerType)
  const isEmbroideryDraw = embroideries?.some(matcher)
  if (!isEmbroideryDraw) return
  const { x, y, numerator } = nonThumbEmbroideryObject[fingerType]
  notThumbEmbroidery(ctx, embroideries.find(matcher), x, y, numerator)
}

export const bottomRightOfBeltEmbroideryDrawer = (ctx: CanvasRenderingContext2D, embroideries: Embroidery[], x: number, y: number): void => {
  const filterFunction = (x: Embroidery) => x.position.value === 'belt'
  const isEmbroideryOfLining = embroideries?.some(filterFunction)
  if (isEmbroideryOfLining) bottomRightOfBeltEmbroidery(ctx, embroideries?.find(filterFunction), x, y)
}

export const sideOfLabelEmbroideryDrawer = (ctx: CanvasRenderingContext2D, embroideries: Embroidery[], x: number, y: number): void => {
  const filterFunction = (x: Embroidery) => x.position.value === 'sideOfLabel'
  const isEmbroideryOfLining = embroideries?.some(filterFunction)
  if (isEmbroideryOfLining) sideOfLabelEmbroidery(ctx, embroideries?.find(filterFunction), x, y)
}

export const dWaveTopEmbroideryDrawer = (
  ctx: CanvasRenderingContext2D,
  embroideries: Embroidery[],
  x: number,
  y: number,
  numerator?: number
): void => {
  const filterFunction = (x: Embroidery) => x.position.value === 'dWaveTop'
  const isEmbroidery = embroideries?.some(filterFunction)
  if (isEmbroidery) dWaveEmbroidery(ctx, embroideries?.find(filterFunction), x, y)
}

export const dWaveBottomEmbroideryDrawer = (
  ctx: CanvasRenderingContext2D,
  embroideries: Embroidery[],
  x: number,
  y: number,
  numerator?: number
): void => {
  const filterFunction = (x: Embroidery) => x.position.value === 'dWaveBottom'
  const isEmbroidery = embroideries?.some(filterFunction)
  if (isEmbroidery) dWaveEmbroidery(ctx, embroideries?.find(filterFunction), x, y)
}
